<img *ngIf="iconSrc" [src]="iconSrc" [alt]="iconAlt" width="28px">
<div class="description">
  <div class="description__minor-text">{{ minorText }}</div>
  <div class="description__main-text">{{ mainText }}</div>
</div>
